import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, InverseButton } from 'react-fast-ui';
import AdminButton from '../layout/AdminButton';

export default class ConfirmDeleteModal extends PureComponent {
  static propTypes = {
    open: PropTypes.bool,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    accentColor: PropTypes.string,
  };

  render() {
    const { open, onClose, onSave, title, accentColor } = this.props;

    return (
      <Modal open={open} onClose={onClose} size="xs">
        <Modal.Title className="color-orange-scout" onClose={onClose}>
          Delete
        </Modal.Title>
        <Modal.Body className="mg-sm">
          <div className="mg-sm">
            <div className="mg-sm text-align-center avenir-medium">
              {title}
            </div>
            <div className="text-align-center mg-lg">
              <div className="display-inline-block mg-sm">
                <AdminButton
                  id={'cancel-delete'}
                  color={accentColor}
                  onClick={onClose}
                  inverse>
                  Cancel
                </AdminButton>
              </div>
              <div className="display-inline-block mg-sm">
                <AdminButton
                  id={'confirm-delete'}
                  color={accentColor}
                  onClick={onSave}>
                  Delete
                </AdminButton>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
